import React from 'react';
import Services from './../services/services';
import Breadcrumb from './../basics/Breadcrumb';
import Steps from './../basics/Steps';
import Moment from 'react-moment';
import ShopHeader from './../shop/ShopHeader';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const TermList = () => {

  let {id} = useParams();

  const [products, setProducts] = useState([]);

  const [places, setPlaces] = useState([]);

  const [selectedProduct, setSelectedProduct] = useState<any>("false");

  const [selectedPlace, setSelectedPlace] = useState<any>("false");

  const [eventList, setEventList] = useState<any>([]);

  let newEventList: any[] = [];

  const productList: any[] = [];

  const placesList: any[] = [];

  const services = new Services();

  useEffect(()=>{

    services.getFreeTerms().then((value: any) => {

      createList(value)

      console.log(value)
    });

    services.getProducts().then( (value: any) => {

      setProducts(value)

    });

    services.getProductPlaces().then( (value: any) => {

      setPlaces(value)

    });

  }, [])

  useEffect(()=>{

    services.getFreeTerms().then((value: any) => {
      
      // if (Array.isArray(value)) {
      //   value.reverse()
      // }

      const newEvents: any[] = [];

      value.map((val: any) => {

        if(selectedProduct !== "false" && selectedPlace !== "false") {

          if(val.product.name == selectedProduct && val.place.name == selectedPlace ) {

            newEvents.push(val);
          }

        }

        if(selectedProduct == "false" && val.place.name == selectedPlace ) {

          newEvents.push(val);

        }

        if(val.product.name == selectedProduct && selectedPlace == "false" ) {

          newEvents.push(val);

        }

        if(selectedProduct == "false" && selectedPlace == "false" ) {

          newEvents.push(val);

        }

      })

      createList(newEvents)

    });

  }, [selectedProduct,selectedPlace])

  products.forEach((data: any) => {

    if( !data.name.includes("Privátní") && !data.name.includes("Romantik") ){
      productList.push(<option value={data.name} >{data.name}</option>)
    }

  })

  places.forEach((data: any) => {

    placesList.push(<option value={data.name} >{data.name}</option>)

  })

  function createList( list: any ){

    newEventList = []

    console.log("test " + list);

    list.forEach((data: any, id: number, array: []) => {

      var link = "";

      if( data.capacity - data.capacityUsed < 1 || data.weight - data.weightUsed < 1){
        link = 'disabled'
      }else{
        link = ''
      }

      newEventList.push(
        <div>

          <div className="d-none d-lg-block">
            <div className="row my-5">
              <div className="d-flex align-items-center flex-column col-2 border-end p-2">
                <Moment className="fw-bold" format="DD.MM.YYYY">
                  {data.startDatetime}
                </Moment>
                <br />
                <Moment format="HH:mm">
                  {data.startDatetime}
                </Moment>
              </div>
              <div className="d-flex align-items-center flex-column col-2 border-end p-2">
                {data.place.name}
              </div>
              <div className="d-flex align-items-center flex-column col-3 border-end p-2">
                {data.product.name}
                <br />
                <Link className="btn btn-sm rounded-pill btn-outline-primary mt-2" to={"/product-detail/"+data.product.id} >Koupit letenky</Link>
              </div>
              <div className="d-flex align-items-center flex-column col-2 border-end p-2">
                {data.balloon.name}
              </div>
              <div className="d-flex align-items-center flex-column col-1 border-end p-2">
                <div><i className="fa-solid fa-person"></i> {data.capacity - data.capacityUsed}</div>
              </div>
              <div className="d-flex align-items-center flex-column col-2 p-4">
                <Link className={'btn btn-lg rounded-pill btn-outline-primary mt-2 ' + link} to={"/passenger-list/"+data.id} >Rezervovat</Link>
              </div>
            </div>
          </div>

          <div className="d-block d-lg-none">
            <div className="row my-5">
              <div className="col-12 border-end">
              <div>
              <span className="fw-bold text-primary">Datum: </span>
                <Moment className="fw-bold" format="DD.MM.YYYY">
                  {data.startDatetime}
                </Moment>
              </div>
              <div>
                <span className="fw-bold text-primary">Čas setkání: </span>
                <Moment format="HH:mm">
                  {data.startDatetime}
                </Moment>
              </div>
              </div>
              <div className="col-12 border-end">
                <span className="fw-bold text-primary">Místo: </span>
                {data.place.name}
              </div>
              <div className="col-12 border-end">
                <span className="fw-bold text-primary">Typ letu: </span>
                {data.product.name} -
                <Link className="text-primary text-decoration-none" to={"/product-detail/"+data.product.id} > Koupit letenky</Link>
              </div>
              <div className="col-12">
                <span className="fw-bold text-primary">Balón: </span>
                {data.balloon.name}
              </div>
              <div className="col-12">
                <span className="fw-bold text-primary">Volná místa: </span>
                {data.capacity - data.capacityUsed}
              </div>
              <div className="col-12">
                <Link className={'btn btn-lg rounded-pill btn-outline-primary mt-2 ' + link} to={"/passenger-list/"+data.id} >Rezervovat</Link>
              </div>
            </div>
          </div>

        </div>
      )

      if (id !== array.length - 1){
         newEventList.push(<hr />)
     }

    })

    if (newEventList.length === 0) {

      newEventList.push(<div className="d-flex justify-content-center text-primary fs-4 my-5">Zvolený typ termínu zatím nemáme</div>);

    }

    setEventList(newEventList)

  }

  const steps = [

    {'name':'Obchod', 'link':'/term-list', 'active': false},
    {'name':'Košík','link': '', 'active': true},
    {'name':'Pokladna','link': '', 'active': true},

  ];

  return (
    <div>

      <ShopHeader title="Termíny letů" image="http://balony.techcrowd.cz/reservation.jpg"/>

      <div className="container py-5">

        <Steps links={steps} />

        <div className="col-12 col-lg-10 mx-auto mt-5 mb-5">
          
          <p className="fs-5 text-primary">Typy letů Klasik a Prémium</p>
          <p className="mb-3"><small>Létáme od května do října. Termíny letů začínáme vypisovat ve druhé polovině dubna zhruba s 4-6 týdenním předstihem. Lokality Pardubice a Hradec Králové budeme létat především po žních - od druhé poloviny července - vzhledem k udržování dobrých vztahů s místními zemědělci.</small></p>

          <p className="fs-5 text-primary">Privátní lety</p>
          <p className="mb-3"><small>Rezervujete si sami telefonicky na čísle <a href="tel:777314444">777314444</a> nebo e-mailem <a href="mailto:info@balonklub.cz">info@balonklub.cz</a>.</small></p>

          <p className="fs-5 text-primary">Expediční lety</p>
          <p className="mb-3"><small>Létáme od října do března. Termíny vypisujeme dle předpovědi počasí.</small></p>

          <p className="fs-5 text-primary">Lety v Alpách</p>
          <p className="mb-3"><small>Létáme 3. týden v lednu v rakouských Alpách. Termíny vypisujeme v prosinci.</small></p>

          <p className="fs-5 text-primary"> Letenky zakoupené před listopadem 2022 si rezervujete telefonicky na čísle <a href="tel:777314444">777314444</a>.</p>

        </div>

        <div className="col-12 col-lg-10 mx-auto mb-4">

        <div className="row">

          <div className="col-12 col-lg-6">
            <div className="fs-5 fw-bold text-primary montserrat">Zvolte typ letu</div>
            <select className="form-select form-select-lg rounded-pill mb-5 form-control-bg border-0 mt-2" onChange={(e) => setSelectedProduct(e.target.value)}>
              <option value="false" selected>Všechny vypsané termíny</option>
              {productList}
            </select>
          </div>

          <div className="col-12 col-lg-6">
            <div className="fs-5 fw-bold text-primary montserrat">Zvolte místo vzletu</div>
            <select className="form-select form-select-lg rounded-pill mb-5 form-control-bg border-0 mt-2" onChange={(e) => setSelectedPlace(e.target.value)}>
              <option value="false" selected>Všechna místa</option>
              {placesList}
            </select>
          </div>

        </div>

        </div>

        <div className="card border-0 custom-radius custom-shadow col-12 col-lg-10 mx-auto">
          <div className="card-body">

          <div className="d-none d-lg-block">
            <div className="row text-primary fw-bold">
              <div className="d-flex align-items-center flex-column col-2 p-4">
                Termín
              </div>
              <div className="d-flex align-items-center flex-column col-2 p-4">
                Místo odletu
              </div>
              <div className="d-flex align-items-center flex-column col-3 p-4">
                Typ letu
              </div>
              <div className="d-flex align-items-center flex-column col-2 p-4">
                Balón
              </div>
              <div className="d-flex align-items-center flex-column col-1 p-4">
                Volná místa
              </div>
              <div className="d-flex align-items-center flex-column col-2 p-4">
                Status
              </div>
            </div>
          </div>

          {eventList}

          </div>
        </div>

      </div>
    </div>
  );

}

export default TermList;
